module.exports = __webpack_public_path__ + "img/equipa.f9c6dcbd.svg";